/**
 * The `/merchants` route (M11), in one place: `App.tsx` routes it and other
 * modules link to it (M3's "All merchants →"), so no copy can drift.
 */
export const MERCHANTS_PATH = '/merchants'
